import { inject, Injectable } from '@angular/core';
import { FIREBASE_PROJECT_ID_PROVIDER } from '@principle-theorem/ng-shared';
import {
  CustomReportCollection,
  IReportRun,
} from '@principle-theorem/principle-core/interfaces';
import {
  docIsFromCollection,
  isWithRef,
  snapshot,
} from '@principle-theorem/shared';
import { ManagementToolSidebarService } from '../management-tool-sidebar.service';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';
import { getStorageBucketLink } from './open-storage-bucket.tool';

@Injectable({ providedIn: 'root' })
export class OpenReportRunStorageTool implements IManagementTool {
  private _sidebarService = inject(ManagementToolSidebarService);
  private _projectId = inject(FIREBASE_PROJECT_ID_PROVIDER);

  readonly name = 'open-report-run-storage';
  readonly label = 'Open Storage Bucket';
  readonly icon = 'cloud';
  readonly description = 'Open the report run results in GCP Storage';
  readonly resource = ManagementResource.ReportRun;

  async isHidden(_context: IToolRunContext): Promise<boolean> {
    const showDevTools = await snapshot(this._sidebarService.showDevTools$);
    return !showDevTools;
  }

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const reportRun = await snapshot(context.resource.value$);
    if (
      !reportRun ||
      !isWithRef<IReportRun>(reportRun) ||
      !docIsFromCollection(reportRun, CustomReportCollection.ReportRuns)
    ) {
      return;
    }
    if (!reportRun.result?.storageUrl) {
      return;
    }
    const url = getStorageBucketLink(
      this._projectId,
      reportRun.result.storageUrl
    );
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
